/* 總覽相關接口 */

import request from '@/utils/http/request'


/* 總覽數據 */
export async function dashboard({ sDate, eDate, areacode, sportType, mchNo, venueCode }) {
    return await request.get('/dashboard', {
        params: {
            sDate, eDate, areacode, sportType, mchNo, venueCode
        }
    });
}

/* 總覽列表 */
export async function dashboard_list({ keyword, pageNumber, pageSize }) {
    return await request.get('/dashboard/list', {
        params: {
            keyword, pageNumber, pageSize
        }
    });
}


/* 總覽導出 */
export async function dashboard_generalExcel({ keyword }) {
    return await request.get('/dashboard/general/excel', {
        params: {
            keyword
        }
    });
}
